import { createGlobalStyle } from 'styled-components';
import { normalize } from 'polished';

import typography from '~/theme/variables/typography';
import color from '~/theme/variables/colors';
import media from '~/theme/variables/breakpoints';
import spacing from './variables/spacing';

const GlobalStyle = createGlobalStyle`
	${normalize()};

	:root {
		box-sizing: border-box;
	}

	*,
	::before,
	::after {
		box-sizing: border-box;
	}

	html,
	body {
		height: 100%;
		margin: 0;
		padding: 0;
		width: 100%;
	}

	body {
		background-color: ${color.background};
		color: ${color.palette.black};
		font-family: ${typography.fontPrimary};
		font-weight: ${typography.fontWeightRegular};
		font-size: ${typography.defaultFontSize}px;
		line-height: ${typography.lineHeightDefault};

		:focus {
			outline: none;
		}

		&.ontario-modal-open {
			overflow: hidden;
			position: static;

			@media ${media.small} {
				position: inherit;
			}
		}

		.ontario-overlay {
			top: 124px;

			@media ${media.small} {
				position: fixed;
				top: 0;
				left: 0;
				right: 0;
				bottom: 0;
				background-color: rgba(255, 255, 255, 0.75);
			}
		}
	}

	a {
		color: ${color.baseLink};
		text-decoration: underline;

		&:visited {
			color: ${color.baseLinkVisited};
		}

		&:hover {
			color: ${color.baseLinkHover};
		}

		&:active {
			color: ${color.baseLinkActive};
		}

		&:focus {
			-moz-box-shadow: 0 0 0 4px ${color.focusBlue};
			-webkit-box-shadow: 0 0 0 4px ${color.focusBlue};
			box-shadow: 0 0 0 4px ${color.focusBlue};
			outline: 4px solid transparent;
			transition: all 0.1s ease-in-out;
		}
	}

	.ontario-text--capitalize::first-letter {
		text-transform: uppercase;
	}
		
    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }
    
    input[type=number] {
      -moz-appearance: textfield;
    }

	.ontario-icon {
		display: inline-block;
        width: 24px;
        height: 24px;
        stroke-width: 0;
        stroke: currentColor;
        fill: currentColor;
        vertical-align: middle;
        overflow: hidden;
        margin-bottom: 2px;
        margin: 0 calc(${spacing.spacing3} / 2) 0 0;
        padding: 0;

		path {
			fill: currentColor;
		}
	}
`;

export default GlobalStyle;
